var render = function render(){var _vm=this,_c=_vm._self._c;return _c('nav',{staticClass:"mobile-menu"},[_c('PageNavigation'),_c('ContactButton',{attrs:{"link":true}}),_c('ImprintLink'),_c('LanguageNavigation')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }